// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navbar_navigation__3Yvjf","item":"Navbar_item__1cUyC","active":"Navbar_active__2GKQ2"};